module.exports = new __parcel__URL__("airmail.789190ba.webp").toString();